const $limit = (collection, expr, _options) => collection.take(expr);
export { $limit };